import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { useEffect } from "react";
import { notifyError } from "@/lib/notifications.ts";
import { isDevelopment } from "@/utils/env.ts";

export default function useQueryApiClient<T>(
    opts: UseQueryOptions<T extends (...args: unknown[]) => unknown ? ReturnType<T> : T>,
) {
    const { error, ...rest } = useQuery(opts);

    useEffect(() => {
        if (!error || !isDevelopment()) return;

        notifyError(error.message);
    }, [error]);

    return { error, ...rest };
}
